import AccountDataFormHandler from '@Modules/cardManagementSystem/cardholder/containers/formHandler/cardData/accountDetail/accountData/AccountDataFormHandler';
import { useParams } from 'react-router-dom';

const AccountDataPage = () => {
    const {id} = useParams();
    const customerId = id || 0;
    
    return (
        <AccountDataFormHandler customerId={customerId} />
    )
}

export default AccountDataPage